$('.content a')
	// Фильтруем навигационные ссылки
	.filter(function () {
		return $(this).parents('nav').length === 0;
	})
	.each(function () {
		var $this = $(this);
		var href = $this.attr('href');
		if (href[0] !== '#') {
			$this.attr('target', '_blank');
		}
		if (href.substring(0, 4) === 'http') {
			$this.addClass('link--external');
		}
	});



/** WEBPACK FOOTER **
 ** ./frontend/components/core/links.js
 **/